import AddIcon from "@mui/icons-material/AddRounded";
import DeleteIcon from "@mui/icons-material/DeleteRounded";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { FormikTextField } from "@shared";

import { useDropdownsSettings } from "@/pages/system-settings/tabs/dropdowns/hooks/useDropdownsSettings";
import { useTranslation } from "@/translations";

import { CategorySelect } from "../category-select/CategorySelect";

export function DropdownsSettingsContent() {
  const { t } = useTranslation();
  const { formik, maxValueLength, isSaving, handleAddRow, handleDeleteRow } = useDropdownsSettings();

  return (
    <Stack flex={1} minHeight={0} gap={3} pt={1}>
      <Box maxWidth={400}>
        <CategorySelect />
      </Box>

      {/* The form is scoped to the value list so Enter inside the category select cannot submit it */}
      <Stack component="form" onSubmit={formik.handleSubmit} flex={1} minHeight={0} gap={3}>
        <Stack flex={1} minHeight={0} gap={2} sx={{ overflowY: "auto" }}>
          <Typography variant="h6">{t("settings.dropdowns.valueList")}</Typography>

          <Stack gap={2}>
            {formik.values.rows.map((row, index) => (
              <Stack key={`${row.id ?? "new"}-${index}`} direction="row" spacing={1} alignItems="flex-start">
                <FormikTextField
                  formik={formik}
                  path={`rows.${index}.value`}
                  placeholder={t("settings.dropdowns.valuePlaceholder")}
                  slotProps={{ input: { inputProps: { maxLength: maxValueLength } } }}
                />
                <IconButton
                  size="small"
                  aria-label={t("settings.dropdowns.deleteEntry")}
                  onClick={() => handleDeleteRow(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Stack>
            ))}
          </Stack>

          <Stack direction="row" justifyContent="flex-end">
            <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddRow}>
              {t("settings.dropdowns.addValue")}
            </Button>
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="flex-end">
          <Button type="submit" variant="contained" disabled={!formik.dirty || isSaving}>
            {t("common.save")}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
